import React from "react";

import { HeroArchiveBlock as HeroArchiveBlockValue } from "@reactivated";

import { ButtonPrimary, ButtonTextPrimary } from "../Clickables";
import { H, HLevel } from "../Headings";
import { Separator } from "../Separator";
import { Svg } from "../Svg";

import styles from "./HeroArchive.module.scss";

export const CTA_TYPE = {
    PRIMARY_BUTTON: "primary_button",
    PRIMARY_TEXT_ICON: "primary_text_icon",
} as const;

interface HeroArchiveProps {
    value: HeroArchiveBlockValue;
}

export const HeroArchive = ({ value }: HeroArchiveProps) => {
    const isPrimaryButton = value.cta_type === CTA_TYPE.PRIMARY_BUTTON;

    return (
        <HLevel>
            <section className={styles.container}>
                <div className={styles.content}>
                    {value.headline && (
                        <H className={styles.headline}>{value.headline}</H>
                    )}

                    <Separator
                        orientation="vertical"
                        className={styles.separator}
                    />

                    <div className={styles.rightContent}>
                        {value.subhead && (
                            <p className={styles.subhead}>{value.subhead}</p>
                        )}
                        {value.cta?.display_name && (
                            <div className={styles.ctaWrapper}>
                                {isPrimaryButton ? (
                                    <ButtonPrimary simpleLink={value.cta} />
                                ) : (
                                    <ButtonTextPrimary simpleLink={value.cta}>
                                        {value.cta.display_name}
                                        <Svg name="arrow" />
                                    </ButtonTextPrimary>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </HLevel>
    );
};
